module.exports = __webpack_public_path__ + "img/quizmayhem_banner_presidents.8d2559a9.jpg";